import { useCallback } from 'react'

import { useAppSelector, useAppDispatch } from 'store/store'

import * as actions from './actions'
import { GameParams } from './types'
import { Game } from 'types/app'

export const useGame = () => {
  const dispatch = useAppDispatch()
  const gameState = useAppSelector(({ game }) => game)
  const singleGameDetails = useAppSelector(({ game }) => game.game)
  const gameIsLoading = useAppSelector(({ game }) => game.isLoading)

  const getAllGames = useCallback(() => {
    dispatch(actions.getAllGames())
  }, [dispatch])

  const createGame = useCallback(
    (payload: GameParams) => {
      dispatch(actions.createGame(payload))
    },
    [dispatch],
  )

  const followGame = useCallback(
    (gameId: string) => {
      dispatch(actions.followGame(gameId))
    },
    [dispatch],
  )

  const requestToBeOwner = useCallback(
    (gameId: string) => {
      dispatch(actions.requestToBeOwner(gameId))
    },
    [dispatch],
  )

  const getAllRequestedGames = useCallback(
    (gameId: string) => {
      dispatch(actions.getAllRequestedGame({ gameId }))
    },
    [dispatch],
  )

  const approveOrRejectRequest = useCallback(
    (id: string, status: string) => {
      dispatch(actions.approveOrRejectRequest({ id, status }))
    },
    [dispatch],
  )
  const cancelOwnerShip = useCallback(
    (gameId: string) => {
      dispatch(actions.cancelOwnerShip({ id: gameId }))
    },
    [dispatch],
  )

  const getGameDetails = useCallback(
    (gameId: string) => {
      dispatch(actions.getGameDetails(gameId))
    },
    [dispatch],
  )

  const updateGame = useCallback(
    (gameId: string, game: Game) => {
      dispatch(actions.updateGame({ gameId, game }))
    },
    [dispatch],
  )

  const deleteGame = useCallback(
    (gameId: string) => {
      dispatch(actions.deleteGameByAdmin(gameId))
    },
    [dispatch],
  )

  const submitGame = useCallback(
    (payload: { name: string; description?: string; url?: string; platform?: string; avatar?: File }) => {
      return dispatch(actions.submitGame(payload)).unwrap()
    },
    [dispatch],
  )

  const verifyGame = useCallback(
    (gameId: string) => {
      return dispatch(actions.verifyGame(gameId)).unwrap()
    },
    [dispatch],
  )

  return {
    ...gameState,
    getAllGames,
    createGame,
    followGame,
    requestToBeOwner,
    getAllRequestedGames,
    approveOrRejectRequest,
    cancelOwnerShip,
    getGameDetails,
    singleGameDetails,
    gameIsLoading,
    updateGame,
    deleteGame,
    submitGame,
    verifyGame,
  }
}
